import { useMountedState } from "react-use";

export { default as useLoading } from "./src/useLoading";
export { default as useOnClickOutside } from "./src/useOnClickOutside";
export { default as useKeyboardShortcuts } from "./src/useKeyboardShortcuts";
export { default as useKey } from "./src/useKey";
export { default as useImageLoader } from "./src/useImageLoader";
export { default as useDebounce } from "./src/useDebounce";
export { default as useSort } from "./src/useSort";
export { default as usePagination } from "./src/usePagination";
export { default as useScrollTo } from "./src/useScrollTo";
export { default as useSize } from "./src/useSize";
export { default as useIntersectionObserver } from "./src/useIntersectionObserver";
export { default as usePages } from "./src/usePages";
export { default as useIsUpdated } from "./src/useIsUpdated";
export { default as useStickyElement } from "./src/useStickyElement";
export { default as useScrollToHash } from "./src/useScrollToHash";
export { default as useDynamicTabName } from "./src/useDynamicTabName";
export { default as usePrevious } from "./src/usePrevious";
export { default as useZIndex } from "./src/useZIndex";
export { default as useFullscreen } from "./src/useFullscreen";
export { default as useSlices } from "./src/useSlices";
export {
  useToggle,
  useDeepCompareEffect,
  useLocalStorage,
  useKeyPressEvent,
  useThrottle,
  useEffectOnce,
  useWindowSize,
  useDebounce as useDebouncedEffect,
  useCopyToClipboard,
  useTimeoutFn,
} from "react-use";
export { default as useHorizontalPagination } from "./src/useHorizontalPagination";

export const useIsMounted = useMountedState;
